// Links out of the portal to the public site (sculpt-website).

/** The website home, reached from the "back to the site" arrow at the top left of every frame. */
export const WEBSITE_URL: string = import.meta.env.VITE_WEBSITE_URL || 'https://sculpt-agent.ai';

/** Where a person writes to exercise their rights (sculpt-api `content/{en,fr}/legal/privacy/`), e.g. to object to the
 *  review of their conversations in the sample. */
export const CONTACT_EMAIL = 'contact@sculpt-agent.ai';

/** "Installation guide": the website's install page (sculpt-website /install), in the portal's language.
 *  VITE_INSTALL_GUIDE_URL, when set, replaces it whatever the language. */
export function installGuideUrl(locale: string): string {
  return import.meta.env.VITE_INSTALL_GUIDE_URL || `${WEBSITE_URL}${locale === 'fr' ? '/fr' : ''}/install`;
}

/** The legal texts a person accepts before creating an account or placing an order (sculpt-api `content/{en,fr}/legal/`),
 *  always the published ones: what is accepted is what the website shows. */
export const LEGAL_URLS = {
  terms: 'https://sculpt-agent.ai/legal#terms',
  dpa: 'https://sculpt-agent.ai/legal#dpa',
  privacy: 'https://sculpt-agent.ai/legal#privacy',
} as const;
